<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Filterrad
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Filterflikar på Alla recept-sidan. Aktiv flik har teal-bakgrund; inaktiva
      har ljusgrå bakgrund.
    </p>

    <PreviewBox label="Klickbar filterrad — pill-variant" bg="#f8fafa">
      <div class="flex gap-2 flex-wrap">
        <button
          v-for="tab in tabs"
          :key="tab"
          class="px-4 py-2 rounded-full border-none cursor-pointer font-[Poppins] font-bold text-[13px] transition-all duration-150"
          :class="
            active === tab
              ? 'bg-teal-500 text-white'
              : 'bg-[#f0f2f4] text-[#6c7a77]'
          "
          @click="active = tab"
        >
          {{ tab }}
        </button>
      </div>
    </PreviewBox>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import { ref } from "vue";
import PreviewBox from "../components/PreviewBox.vue";
import CodeBlock from "../components/CodeBlock.vue";

const htmlCode = `<div class="flex gap-2 flex-wrap">
  <button
    v-for="tab in tabs"
    :key="tab"
    class="px-4 py-2 rounded-full border-none cursor-pointer font-[Poppins] font-bold text-[13px] transition-all"
    :class="active === tab ? 'bg-teal-500 text-white' : 'bg-[#f0f2f4] text-[#6c7a77]'"
    @click="active = tab"
  >
    {{ tab }}
  </button>
</div>`;
const cssCode = `/* Filterpill */
border-radius: 9999px;   /* rounded-full */
border: none;
cursor: pointer;
font-family: 'Poppins', sans-serif;
font-weight: 700;
font-size: 13px;

/* Aktiv */
background: #14b8a6;
color: white;

/* Inaktiv */
background: #f0f2f4;
color: #6c7a77;`;

const snippetTabs = [
  { label: "HTML", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
const active = ref("Alla");
const tabs = ["Alla", "Middag", "Pasta", "Sallad", "Vegetarisk"];
</script>
